<template>
  <div class="d-flex flex-column flex-grow-1">
    <filtered-data
      ref="data"
      v-model="data"
      endpoint="modems/broadcasts"
      :loading.sync="loading"
      :hasMore.sync="hasMore"
      :filtersValue="filtersValue"
    ></filtered-data>

    <template v-if="data && data.data">
      <data-table-full-height
        :data="data.data"
        @load-more="$refs.data.loadMore"
        :hasMore="hasMore"
        :loading="loading"
      >
        <el-table-column type="expand">
          <template slot-scope="{row}">
            <vue-json-pretty :data="row.filters"/>
          </template>
        </el-table-column>
        <el-table-column prop="type" label="Тип" width="120">
          <template slot-scope="{row}">
            <router-link
              class="text-monospace text-muted"
              :to="`/modems/broadcasts/${row.id}`"
              v-text="row.type"
            />
          </template>
        </el-table-column>
        <el-table-column prop="" label="Пользователь" min-width="300">
          <template slot-scope="{row}">{{row.user | fullName}}</template>
        </el-table-column>
        <table-column-number align="center" prop="commands_count" label="Отправлено команд" min-width="120"/>
        <el-table-column prop="" label="Дата рассылки" width="220">
          <template slot-scope="{row}">
            <div v-if="row.requested_at">{{row.requested_at | formatDate}}</div>
            <div v-else>В ожидании</div>
          </template>
        </el-table-column>
        <table-column-date label="Назначенная дата"/>
      </data-table-full-height>
    </template>
  </div>
</template>

<script>
  import VueJsonPretty from 'vue-json-pretty'

  export default {
    metaInfo: {title: 'Рассылки'},
    components: {VueJsonPretty},
    data () {
      return {
        data: {},
        loading: false,
        hasMore: true,
        filtersValue: {},
      }
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/modems/index/broadcasts/index.vue